import React, { useContext, useState, useEffect } from 'react';
import AppLayout from 'components/AppLayout/AppLayout';
import AppDrawer from 'components/AppDrawer/AppDrawer';
import Widget from 'components/Widget/Widget';
import Grid from '@mui/material/Grid';

import AssessmentList from 'components/ExecutiveView/AssessmentList';
import AssessmentScore from 'components/ExecutiveView/AssessmentScore';
import AssessmentRisks from 'components/ExecutiveView/AssessmentRisks';
import RiskChart from 'pages/Strategy/RiskChart';

import PolicyIcon from '@mui/icons-material/Policy';
import WarningIcon from '@mui/icons-material/Warning';
import ListIcon from '@mui/icons-material/List';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import theme from 'theme';

import 'i18n/config';
import { useTranslation } from 'react-i18next';

import { DataContext } from 'contexts/DataContext';
import { assessmentList, assessmentRisk } from 'components/ExecutiveView/api';
import PostureChart from 'components/ExecutiveView/PostureChart';
import StatusChart from 'components/ExecutiveView/StatusChart';

function ExecutiveView() {
  const dataContext = useContext(DataContext)
  const [currentOrganization, setCurrentOrganization] = useState('');
  const [assessment, setAssessments] = useState([] as any);
  const [posture, setPosture] = useState(false as any);
  const [status, setStatus] = useState(false as any);
  const [total, setTotal] = useState(false as any);
  const [assessmentsRisks, setAssessmentsRisks] = useState([] as any);
  const [maxAssessmentsRisks, setMaxAssessmentsRisks] = useState(false as any);
  const {t} = useTranslation();
  const [show, setShow] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setShow(true);
    }, 500);
  }, []);

  useEffect(()=>{
    if(dataContext.loading) return;
    if(!dataContext.currentOrganization) return;
    
    dataContext.changeShowLoader(true);
    setCurrentOrganization(dataContext.currentOrganization)

    assessmentList(dataContext.currentOrganization).then(response=>{
      setAssessments(response);
      console.log(response);
      let sumFncsScore = 0;
      let sumGdprScore = 0;
      let sumPsncScore = 0;
      let sumNis2Score = 0;
      let sumFncsMaturity = 0;
      let sumGdprMaturity= 0;
      let sumPsncMaturity = 0;
      let sumNis2Maturity = 0;

      let statusTotalScore = 0;
      let statusTotalMaturity = 0;
      let sumDetectScore = 0;
      let sumIdentifyScore = 0;
      let sumProtectScore = 0;
      let sumRecoverScore = 0;
      let sumRespondScore= 0;
      let sumDetectMaturity = 0;
      let sumIdentifyMaturity = 0;
      let sumProtectMaturity = 0;
      let sumRecoverMaturity = 0;
      let sumRespondMaturity= 0;

      response.map((a:any) => {
        sumFncsScore = sumFncsScore + a.score.fncs
        sumGdprScore = sumGdprScore + a.score.gdpr
        sumPsncScore = sumPsncScore + a.score.psnc
        sumNis2Score = sumNis2Score + a.score.nis2

        sumFncsMaturity = sumFncsMaturity + a.maturity.fncs
        sumGdprMaturity = sumGdprMaturity + a.maturity.gdpr
        sumPsncMaturity = sumPsncMaturity + a.maturity.psnc
        sumNis2Maturity = sumNis2Maturity + a.maturity.nis2
        return 0;
      });
      response.map((assessment:any) => {
        assessment.status?.map((a:any) => {
          if(a.category==="DETECT (DE)") {
            sumDetectScore = sumDetectScore + a.value1;
            sumDetectMaturity = sumDetectMaturity + a.value2;
          }
          if(a.category==="IDENTIFY (ID)") {
            sumIdentifyScore = sumIdentifyScore + a.value1;
            sumIdentifyMaturity = sumIdentifyMaturity + a.value2;
          }
          if(a.category==="PROTECT (PR)") {
            sumProtectScore = sumProtectScore + a.value1;
            sumProtectMaturity = sumProtectMaturity + a.value2;
          }
          if(a.category==="RECOVER (RC)") {
            sumRecoverScore = sumRecoverScore + a.value1;
            sumRecoverMaturity = sumRecoverMaturity + a.value2;
          }
          if(a.category==="RESPOND (RS)") {
            sumRespondScore = sumRespondScore + a.value1;
            sumRespondMaturity = sumRespondMaturity + a.value2;
          }
          return 0;
        });
        statusTotalScore = assessment.score?.all;
        statusTotalMaturity = assessment.maturity?.all;
      return 0;
      });

      setPosture({
        score: {
          'fncs' : Math.round(sumFncsScore / response.length) || 0,
          'gdpr' : Math.round(sumGdprScore / response.length) || 0,
          'psnc' : Math.round(sumPsncScore / response.length) || 0,
          'nis2' : Math.round(sumNis2Score / response.length) || 0,
        },
        maturity: {
          'fncs' : Math.round(sumFncsMaturity / response.length) || 0,
          'gdpr' : Math.round(sumGdprMaturity / response.length) || 0,
          'psnc' : Math.round(sumPsncMaturity / response.length) || 0,
          'nis2' : Math.round(sumNis2Maturity / response.length) || 0,
        }
      });
      setStatus([
        {
          "category": "IDENTIFY (ID)",
          "value1":  Math.round(sumIdentifyScore / response.length) || 0,
          "value2": Math.round(sumIdentifyMaturity / response.length) || 0,
        },
        {
          "category": "PROTECT (PR)",
          "value1":  Math.round(sumProtectScore / response.length) || 0,
          "value2": Math.round(sumProtectMaturity / response.length) || 0,
        },
        {
            "category": "DETECT (DE)",
            "value1":  Math.round(sumDetectScore / response.length) || 0,
            "value2": Math.round(sumDetectMaturity / response.length) || 0,
        },
        {
          "category": "RESPOND (RS)",
          "value1":  Math.round(sumRespondScore / response.length) || 0,
          "value2": Math.round(sumRespondMaturity / response.length) || 0,
        },
        {
          "category": "RECOVER (RC)",
          "value1":  Math.round(sumRecoverScore / response.length) || 0,
          "value2": Math.round(sumRecoverMaturity / response.length) || 0,
        }
      ]);
      setTotal({
        score: Math.round(statusTotalScore / response.length) || 0,
        maturity: Math.round(statusTotalMaturity / response.length) || 0,
      })
    });

    assessmentRisk(dataContext.currentOrganization).then(response=>{
      setAssessmentsRisks(response);
      let maxAssessmentsRisks = Math.max(...response.map((o:any) => o.risk_detail));
      maxAssessmentsRisks = maxAssessmentsRisks < 0 ? 0 : maxAssessmentsRisks;
      setMaxAssessmentsRisks(maxAssessmentsRisks);
      dataContext.changeShowLoader(false);
    });
    //eslint-disable-next-line
  },[dataContext.loading, dataContext.currentOrganization])
  return (
    <AppLayout drawerOpen={true} drawer={<AppDrawer />}>
      {dataContext.currentOrganization &&
      <Grid container spacing={2}>
        <Grid item xs={8}>
        <Widget title="Cyber Security Posture" icon={<PolicyIcon />}>
        
        <Grid container sx={{minHeight:300}}>
        <Grid item xs={12}>
          {currentOrganization && posture!==false && 
          <PostureChart key={"posture-"+currentOrganization} posture={posture} />}
        </Grid>

         <Grid item xs={6}>
          {false && currentOrganization && posture!==false && 
          <StatusChart key={"posture-"+currentOrganization} status={status} total={total} />}

        </Grid>
        </Grid>

        </Widget>
          {/*  */}
        </Grid>

        <Grid item xs={4}>

        <Widget title="Cyber Risk" icon={<WarningIcon />}>
          {maxAssessmentsRisks!==false && 
          <RiskChart name="maxRisk" value={maxAssessmentsRisks} />}
        </Widget>
        
        </Grid>

        {/*
        <Grid item xs={4}>
          <Widget title="Activity Progress" icon={<PublicIcon />}>
          {currentOrganization && 
          <ConfigurationProgress currentOrganization={currentOrganization}  />}
          </Widget>
        </Grid>
 */}

        <Grid item xs={6}>
          <Widget title="Posture by Assessment" icon={<PolicyIcon />}>
          {assessment.length>0 && 
          <AssessmentScore assessments={assessment}  />}
          </Widget>
        </Grid>

        <Grid item xs={6}>

        <Widget title="Risk by Assessment" icon={<WarningIcon />}>
          {assessmentsRisks.length>0 && 
          <AssessmentRisks assessments={assessmentsRisks}  />}
          </Widget>

        </Grid>

        <Grid item xs={12}>
        {currentOrganization && 
          <Widget title="Assessment List" icon={<ListIcon />}>
          <AssessmentList currentOrganization={currentOrganization} />
          </Widget>}
        </Grid>

      </Grid>}

      {!dataContext.currentOrganization && <>
        <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          color: theme.palette.primary.main,
          transition: 'opacity 0.5s',
          opacity: show ? 1 : 0,
        }}
      >
        {/* 
        <Typography variant="h1" style={{ fontFamily: 'Saira Semi Condensed', fontSize:200, color: theme.palette.primary.main }}>
          404
        </Typography>
        */}
        <Typography variant="h3" style={{ fontFamily: 'Saira Semi Condensed', color: 'white' }}>
          {t('Select an organization')}
        </Typography>
      </Box>
      </>
      
      }
        {/* 
        <Grid container spacing={2}>
            <Grid item xs={8}>
                <Widget title="Map chart" icon={<PublicIcon />}>
                  <Chart3 />
                </Widget>
            </Grid>
            <Grid item xs={4}>
              <Grid item xs={12}>
                <Widget title="Bar line chart" icon={<BarChartIcon />}>
                  <Chart1 />
                </Widget>
            
                <Widget title="Pie chart" icon={<PieChartIcon />}>
                  <Chart2 />
                </Widget>
              </Grid>            
            </Grid>

            <Grid item xs={4}>
                <Widget title="Gauge chart" icon={<SpeedIcon />}>
                  <Chart4 />
                </Widget>
            </Grid>
            <Grid item xs={4}>
                <Widget title="Donut chart" icon={<DonutLargeIcon />}>
                  <Chart5 />
                </Widget>
            </Grid>
            <Grid item xs={4}>
                <Widget title="Gauge chart" icon={<SpeedIcon />}>
                  <Chart6 />
                </Widget>
            </Grid>
        </Grid>
        */}
    </AppLayout>
  );
}

export default ExecutiveView;
